import Vue from 'vue';
import '../../public/js/coep-embeds.js';

function render(el, value) {
  el.innerHTML = window.NtuaCoep.prepareHtml(value);
}

Vue.directive('coep-html', {
  bind(el, binding) {
    render(el, binding.value);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) render(el, binding.value);
  }
});
